import type { AccessPolicyValue } from '../rbac/types';

import { DockerRegistryFormData, DockerRegistryPolicyPayload } from './types';

/**
 * Builds the API payload from form data
 * Converts form rows into per-registry access policies (binary access, no roles)
 */
export function buildDockerRegistryPayload(
  formData: DockerRegistryFormData
): DockerRegistryPolicyPayload {
  const registryAccessPolicies = formData.accessRows.reduce<
    DockerRegistryPolicyPayload['RegistryAccessPolicies']
  >((acc, { registryId, userIds, teamIds }) => {
    const regIdStr = registryId.toString();

    const existing = acc[regIdStr] || {
      UserAccessPolicies: {},
      TeamAccessPolicies: {},
    };

    const newUserPolicies = userIds.reduce<Record<string, AccessPolicyValue>>(
      (userAcc, userId) => ({
        ...userAcc,
        [userId.toString()]: {
          RoleId: { value: 0, enforce: false },
        },
      }),
      existing.UserAccessPolicies
    );

    const newTeamPolicies = teamIds.reduce<Record<string, AccessPolicyValue>>(
      (teamAcc, teamId) => ({
        ...teamAcc,
        [teamId.toString()]: {
          RoleId: { value: 0, enforce: false },
        },
      }),
      existing.TeamAccessPolicies
    );

    return {
      ...acc,
      [regIdStr]: {
        UserAccessPolicies: newUserPolicies,
        TeamAccessPolicies: newTeamPolicies,
      },
    };
  }, {});

  return {
    RegistryAccessPolicies: registryAccessPolicies,
  };
}
